import React from "react"

import Section from "../template-parts/product-marketing/Section"
import { officeHours } from "../../config"
import ContactHeroBlock from "../template-parts/ContactHeroBlock"

const Help = () => (
  <Section
    head="How Can we Help?"
    subhead={`Our customer service team is available ${officeHours}.`}
  >
    <ContactHeroBlock />
  </Section>
)

export default Help
